export const palette = {
  id: 'yuletide',
  displayName: 'Yuletide',
  graph: {
    writeSample: '#9F1F2E', writeTrend: 'rgba(159, 31, 46, 0.67)',
    writeMax: '#D15263', writeMin: '#6F121E', writeLatency: '#9F1F2E',
    readSample: '#1D5A3A', readTrend: 'rgba(29, 90, 58, 0.67)',
    readMax: '#5C8F70', readMin: '#103825', readLatency: '#1D5A3A',
  },
  canvas: {
    chartBg: '#F8FCF8', gridColor: '#E4EEE6', textColor: '#1B2E22',
  },
};

const yuletide = {
  id: 'yuletide',
  displayName: 'Yuletide',
  baseType: 'light',
  enabled: false,
  linkedPalette: 'yuletide',
  palette,
  ui: {
    headerBg: '#F8FCF8', headerText: '#1B2E22', accentColor: '#9F1F2E',
    mainBg: '#EAF4EC', mainText: '#1B2E22', mainTextHeading: '#1B2E22',
    mainHeroText: '#FFFFFF', footerBg: '#F8FCF8', footerText: '#1B2E22',
    cardBg: '#FFFFFF', cardText: '#1B2E22', cardBorder: '#1D5A3A',
    cardButtonBg: '#1D5A3A', cardButtonText: '#FFFFFF',
    navLinkText: '#1B2E22', navLinkHover: '#9F1F2E', navLinkActive: '#1B2E22',
    listGroupBg: '#EAF4EC', bmrkDetailBg: '#1D5A3A',
    bmrkMetricBg: '#FFFFFF', bmrkMetricText: '#1B2E22', bmrkMetricBorder: '#1D5A3A',
    mainCardText: '#1B2E22', navLinkFocus: '#1B2E22', navEmailActive: '#1B2E22',
    homeProseLabel: '#9F1F2E', homeProseLink: '#1B2E22', homeProseDlBtn: '#1B2E22',
    cardButtonBorder: '#1D5A3A', linkColor: '#9F1F2E', cardTextMuted: '#5D6B62',
  },
};
export default yuletide;
